//Styled Components
import styled from "styled-components";
//Styles
export default styled.div`
  .performancePeriod {
    max-width: 185px;
  }
`;